module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjYzEwMDAwIiBkPSJNMCAwaDY0MHY0ODBIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMjQ5Ljk1NHYyMDAuMzIxSDB6Ii8+CiAgICA8ZyBmaWxsPSIjYzEwMDAwIj4KICAgICAgPHBhdGggZD0iTTEwMi44NTQgMzEuMjRoMzkuODR2MTM5LjU0aC0zOS44NHoiLz4KICAgICAgPHBhdGggZD0iTTE5Mi41NSA4MS4wODZ2MzkuODRINTMuMDF2LTM5Ljg0eiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/to.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/to.svg
// module chunks = 0